import { Loader2, WifiOff } from 'lucide-react';

interface FullPageLoaderProps {
  message?: string;
  showOffline?: boolean;
}

/**
 * Full-page loading spinner for route transitions and async operations.
 * Consolidates the duplicated loading pattern across gate components. (TD-007)
 */
export function FullPageLoader({ message, showOffline }: FullPageLoaderProps) {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center gap-3">
      <Loader2 className="w-8 h-8 animate-spin text-primary" />
      {showOffline && (
        <div className="flex items-center gap-2 text-muted-foreground text-sm">
          <WifiOff className="w-4 h-4" />
          <span>Loading offline...</span>
        </div>
      )}
      {message && !showOffline && (
        <p className="text-muted-foreground text-sm">{message}</p>
      )}
    </div>
  );
}
